var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "gene-set-cart-2kc-table" }, [
    _c("div", { staticClass: "d-flex justify-content-end mb-2" }, [
      _c(
        "button",
        {
          staticClass:
            "btn btn-sm btn-outline-secondary d-inline-flex align-items-center",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("download-raw-json")
            },
          },
        },
        [
          _c("b-icon", {
            staticClass: "mr-1",
            attrs: { icon: "download", "aria-hidden": "true" },
          }),
          _vm._v(" Raw data "),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "reveal-factor-table-wrap" },
      [
        _c("b-table", {
          attrs: {
            items: _vm.rowsPaged,
            "primary-key": "_rowKey",
            fields: _vm.tableFields,
            small: "",
            striped: "",
            hover: "",
            "head-variant": "light",
          },
          scopedSlots: _vm._u([
            {
              key: "cell(factor)",
              fn: function (row) {
                return [
                  _c("span", { staticClass: "reveal-soft-wrap-cell" }, [
                    _vm._v(
                      _vm._s(
                        _vm.softWrapAtUnderscore(
                          _vm.getFactorClusterDisplay(row.item)
                        )
                      )
                    ),
                  ]),
                ]
              },
            },
            {
              key: "cell(geneSetCount)",
              fn: function (row) {
                return [
                  _vm._v(
                    " " + _vm._s(_vm.getGeneSetCountForRow(row.item)) + " "
                  ),
                ]
              },
            },
            {
              key: "cell(geneCount)",
              fn: function (row) {
                return [
                  _vm._v(
                    " " +
                      _vm._s(_vm.getGeneSearchContextCountDisplay(row.item)) +
                      " "
                  ),
                ]
              },
            },
            {
              key: "cell(view_genes)",
              fn: function (row) {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-outline-primary",
                      on: {
                        click: function ($event) {
                          return _vm.$emit("toggle-factor-row", row)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.isFactorRowExpanded(row.item) ? "Hide" : "Show"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]
              },
            },
            {
              key: "row-details",
              fn: function (row) {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "bg-light",
                      staticStyle: {
                        display: "flex",
                        gap: "20px",
                        "flex-wrap": "wrap",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "px-3 pt-2 pb-0 w-100" },
                        [
                          _vm.getFactorConnectivityNetwork(row.item) &&
                          _vm.getFactorConnectivityNetwork(row.item).nodes
                            .length
                            ? _c("factor-base-reveal-network", {
                                attrs: {
                                  network: _vm.getFactorConnectivityNetwork(
                                    row.item
                                  ),
                                  height: 220,
                                  "show-popup-button": true,
                                  "keep-physics-enabled": "",
                                  "gene-node-metric-key": "gwas_support",
                                  "gene-color-by-gwas-support": "",
                                  "edge-distance-metric-key":
                                    "functional_support",
                                },
                                on: {
                                  "open-popup": function ($event) {
                                    return _vm.$emit(
                                      "open-factor-connectivity",
                                      row.item
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm.getGenesetForFactor(
                        row.item.phenotype,
                        row.item.factor,
                        row.item.fetched_direction
                      ).length
                        ? _c(
                            "div",
                            {
                              staticClass: "py-2 px-3",
                              staticStyle: {
                                display: "flex",
                                flex: "1",
                                "flex-direction": "column",
                              },
                            },
                            [
                              _c("b-table", {
                                attrs: {
                                  striped: "",
                                  hover: "",
                                  small: "",
                                  responsive: "sm",
                                  "head-variant": "light",
                                  items: _vm.getGenesetForFactor(
                                    row.item.phenotype,
                                    row.item.factor,
                                    row.item.fetched_direction
                                  ),
                                  fields: _vm.geneSetSubtableFields,
                                  "per-page": _vm.subtablePerPage,
                                  "current-page":
                                    _vm.getGeneSetSubtableCurrentPage(row.item),
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "cell(geneset)",
                                      fn: function (gsRow) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "reveal-soft-wrap-cell",
                                              attrs: {
                                                title: gsRow.item.geneset,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.softWrapAtUnderscore(
                                                    gsRow.item.geneset
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                              _vm.getGenesetForFactor(
                                row.item.phenotype,
                                row.item.factor,
                                row.item.fetched_direction
                              ).length > _vm.subtablePerPage
                                ? _c("b-pagination", {
                                    staticClass:
                                      "pagination-sm justify-content-center mt-2",
                                    attrs: {
                                      value:
                                        _vm.subtableCurrentPages[
                                          _vm.getRowKey(row.item) + "|gs"
                                        ] || 1,
                                      "total-rows": _vm.getGenesetForFactor(
                                        row.item.phenotype,
                                        row.item.factor,
                                        row.item.fetched_direction
                                      ).length,
                                      "per-page": _vm.subtablePerPage,
                                    },
                                    on: {
                                      input: function ($event) {
                                        _vm.$emit("update:subtable-page", {
                                          rowKey:
                                            _vm.getRowKey(row.item) + "|gs",
                                          page: $event,
                                        })
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "subtable-container py-2",
                          staticStyle: { flex: "1" },
                        },
                        [
                          _c("b-table", {
                            attrs: {
                              striped: "",
                              hover: "",
                              small: "",
                              responsive: "sm",
                              "head-variant": "light",
                              items: _vm.getGenesForFactor(
                                row.item.phenotype,
                                row.item.factor,
                                row.item.fetched_direction
                              ),
                              fields: _vm.geneSubtableFields,
                              "per-page": _vm.subtablePerPage,
                              "current-page": _vm.getSubtableCurrentPage(
                                row.item
                              ),
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "cell(gene)",
                                  fn: function (gRow) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          style:
                                            gRow.item.inSearch ||
                                            gRow.item.userRequested === "Yes"
                                              ? { fontWeight: 700 }
                                              : { fontWeight: 400 },
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(gRow.item.gene) + " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(inSearch)",
                                  fn: function (gRow) {
                                    return [
                                      gRow.item.inSearch
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "text-success",
                                              attrs: {
                                                "aria-label": "In search",
                                              },
                                            },
                                            [_vm._v("✓")]
                                          )
                                        : _c(
                                            "span",
                                            { staticClass: "text-muted" },
                                            [_vm._v("—")]
                                          ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _vm.getGenesForFactor(
                            row.item.phenotype,
                            row.item.factor,
                            row.item.fetched_direction
                          ).length > _vm.subtablePerPage
                            ? _c("b-pagination", {
                                staticClass:
                                  "pagination-sm justify-content-center mt-2",
                                attrs: {
                                  value:
                                    _vm.subtableCurrentPages[
                                      _vm.getRowKey(row.item)
                                    ] || 1,
                                  "total-rows": _vm.getGenesForFactor(
                                    row.item.phenotype,
                                    row.item.factor,
                                    row.item.fetched_direction
                                  ).length,
                                  "per-page": _vm.subtablePerPage,
                                },
                                on: {
                                  input: function ($event) {
                                    _vm.$emit("update:subtable-page", {
                                      rowKey: _vm.getRowKey(row.item),
                                      page: $event,
                                    })
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              },
            },
          ]),
        }),
        _vm.rowCount > _vm.mainTablePerPage
          ? _c("b-pagination", {
              staticClass: "pagination-sm justify-content-center mt-2",
              attrs: {
                value: _vm.mainTableCurrentPage,
                "total-rows": _vm.rowCount,
                "per-page": _vm.mainTablePerPage,
              },
              on: {
                input: function ($event) {
                  return _vm.$emit("update:mainTableCurrentPage", $event)
                },
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }